"use client";

import React from "react";
import { ContactSubmit } from "../common/button";
import { fetchReceiveEmail } from "@/src/service/apiService";
import { useToast } from "@/src/hooks/use-toast";

const ContactForm = () => {
  // const [state, setState] = useState(initState);
  // const [touched, setTouched] = useState({});

  const [isLoading, setIsLoading] = React.useState(false);

  const { toast } = useToast();

  const onSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    if (isLoading) return;

    setIsLoading(true);
    const formData = new FormData(e.currentTarget);
    const body = {
      name: formData.get("name") as string,
      email: formData.get("email") as string,
      subject: formData.get("subject") as string,
      message: formData.get("message") as string,
    };

    console.log(body);

    try {
      await fetchReceiveEmail(body);
    } catch (error: any) {
      toast({
        className: "bg-main-100",
        description: `${error?.message as string}`,
      });
      e?.preventDefault();
    }
    // await new Promise<void>((resolve) => setTimeout(resolve, 3000));

    toast({
      className: "bg-main-100",
      description: "Your message has been sent.",
    });
    setIsLoading(false);
  };

  return (
    <form action="" onSubmit={onSubmit}>
      <div className="mb-6 grid gap-6 md:grid-cols-2">
        <div className="">
          {/* Name */}
          <label
            htmlFor="name"
            className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
          >
            Name
          </label>
          <input
            type="text"
            id="name"
            name="name"
            className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-main-500 focus:ring-main-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
            placeholder="name"
            required
          />
        </div>

        {/* Email */}
        <div className="">
          <label
            htmlFor="email"
            className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
          >
            Email address
          </label>
          <input
            type="email"
            id="email"
            name="email"
            className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-main-500 focus:ring-main-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
            placeholder="john.doe@company.com"
            required
          />
        </div>
      </div>

      {/* Subject */}
      <div className="mb-6">
        <label
          htmlFor="subject"
          className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
        >
          Subject
        </label>
        <input
          type="text"
          id="subject"
          name="subject"
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-main-500 focus:ring-main-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
          placeholder="name"
          required
        />
      </div>

      {/* Message */}
      <div className="mb-6">
        <label
          htmlFor="message"
          className="mb-2 block text-sm font-medium text-gray-900 dark:text-white"
        >
          Message
        </label>
        <textarea
          id="message"
          name="message"
          maxLength={200}
          rows={5}
          className="block w-full rounded-lg border border-gray-300 bg-gray-50 p-2.5 text-sm text-gray-900 focus:border-main-500 focus:ring-main-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500"
          placeholder="Enter your message"
          required
        />
      </div>

      <ContactSubmit isLoading={isLoading} />
    </form>
  );
};

export default ContactForm;
